<template>
  <div
    :style="
      `${
        $vuetify.breakpoint.smAndUp ? 'max-height: 80vh;' : 'max-height: 95vh; min-height: 88vh;'
      }; overflow: auto;`
    "
    class="expande-horizontal windows-style-content"
  >
    <v-flex xs12 :md9="!hideActions" :md12="hideActions">
      <div class="pa-3 expande-horizontal wrap">
        <v-flex v-if="$vuetify.breakpoint.smAndDown" xs12>
          <div class="expande-horizontal centraliza pt-8 wrap">
            <v-chip
              @click="configureDeliveryNote"
              small
              class="ma-1 delivery-note-chip"
              > <v-icon left size="15">mdi-cloud-print-outline</v-icon>
                Nota de entrega
            </v-chip>
            <v-chip
              @click="openReceiptEmitter"
              small
              :color="$theme.primary"
              dark
              class="ma-1"
              >Recibo
            </v-chip>
            <v-chip
              @click="sendToPdv(get_gestordepedido._id)"
              small
              :color="$theme.primary"
              dark
              class="ma-1"
              >pdv
            </v-chip>
             <v-chip
              @click="printReceipt(get_gestordepedido)"
              small
              :color="$theme.primary"
              dark
              class="ma-1"
              >Imprimir
            </v-chip>
            <v-chip
              v-if="!get_gestordepedido.external_movimentation"
              @click="prepareDelivery(get_gestordepedido)"
              small
              :color="$theme.primary"
              dark
              class="ma-1"
              >Agendamento
            </v-chip>
            <!-- <v-chip
              @click="initPayment"
              small
              :color="$theme.primary"
              dark
              class="ma-1"
              v-if="get_gestordepedido.status_do_pagamento === 'pendente'"
              >pagamento
            </v-chip> -->
          </div>
        </v-flex>
        <in-preparation-stage />
        <!-- Editor de desenho técnico (coluna do meio) -->
        <sale-technical-drawing-panel
          @print-technical-drawing="printTechnicalDrawing && printTechnicalDrawing()"
        />
        <MembersPlugin
          origin="sale"
          :dataOrigin="{ ...get_gestordepedido, state: 'progress-view' }"
        />
        <TagPlugin
          :dataOrigin="get_gestordepedido.compra.tags || []"
          :dataSale="get_gestordepedido"
        />
      </div>
      <files
        :v-model="get_gestordepedido.files"
        :value="get_gestordepedido.files || []"
        :sale="get_gestordepedido"
        @input="updateFiles($event)"
      />
      <view-external-movimentation
        v-if="get_gestordepedido.external_movimentation"
        :external_movimentation="get_gestordepedido.external_movimentation"
        :openEvent="editDelivery"
      />
      <v-flex v-if="deliveryNotes.length" class="pa-2" xs12>
        <section class="delivery-notes-panel" :class="{ dark: isDark }">
          <div class="delivery-notes-header">
            <v-avatar class="delivery-notes-icon" size="38">
              <v-icon>mdi-file-document-check-outline</v-icon>
            </v-avatar>
            <div>
              <strong>Notas de entrega</strong>
              <small>Documentos emitidos para esta venda</small>
            </div>
          </div>

          <article
            v-for="note in deliveryNotes"
            :key="note._id || note.number"
            class="delivery-note-row"
          >
            <div class="delivery-note-main">
              <strong>{{ note.number || "Nota de entrega" }}</strong>
              <small>
                Emitida por {{ personName(note.issued_by) }} em {{ $moment(note.issued_at).format("lll") }}
                <span v-if="note.print_count"> - {{ note.print_count }} impressao{{ note.print_count > 1 ? "es" : "" }}</span>
              </small>
            </div>
            <v-btn
              small
              outlined
              :loading="reprintingNote === (note._id || note.number)"
              :color="$theme.primary"
              @click="reprintDeliveryNote(note)"
            >
              <v-icon left size="16">mdi-printer-outline</v-icon>
              Reimprimir
            </v-btn>
          </article>
        </section>
      </v-flex>
      <!-- <PlateViewer /> -->
      <payment-logs
        v-if="get_gestordepedido.compra"
        :payments="get_gestordepedido.historico_de_pagamento || []"
        :total="paymentTotal"
        :paid="paymentPaid"
        :remaining="paymentRemaining"
        :status="get_gestordepedido.status_do_pagamento"
      />
      
      <sale-tenant-movement-panel @print-exit-note="printExitNote && printExitNote($event)" />
      <sale-log />
    </v-flex>
    <v-flex v-if="$vuetify.breakpoint.lgAndUp && !hideActions" class="pa-3" md3>
      <span class="fonte fonteMini grey--text"> Opções: </span>
      <v-list nav color="transparent" class="pa-0 ma-0" dense>
        <v-list-item
          @click="sendToPdv(get_gestordepedido._id)"
          style="border-radius: 6px; margin-bottom: 6px; background: #e5e5e5;"
        >
          <v-icon size="18" class="mr-2">mdi-calculator</v-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span class="fonte">Abrir no PDV</span>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="grey" size="21">mdi-open-in-new</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item
          @click="configureDeliveryNote"
          class="sale-option-item sale-option-delivery"
        >
          <span class="sale-option-icon">
            <v-icon size="18">mdi-cloud-print-outline</v-icon>
          </span>
          <v-list-item-content>
            <v-list-item-title>
              <span class="fonte">Imprimir Nota de entrega</span>
            </v-list-item-title>
            <v-list-item-subtitle>
              <span class="fonte fonteMini">Emitir nova ou reimprimir a atual</span>
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon color="grey" size="20">mdi-chevron-right</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item
          @click="initPayment"
          style="border-radius: 6px; margin-bottom: 6px; background: #e5e5e5;"
        >
          <v-icon size="18" class="mr-2">mdi-printer-outline</v-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span
                v-if="get_gestordepedido.status_do_pagamento === 'pendente'"
                class="fonte"
                >Imprimir Recibo</span
              >
              <span
                v-if="get_gestordepedido.status_do_pagamento === 'pago'"
                class="fonte green--text font-weight-bold"
                >Paga</span
              >
            </v-list-item-title>
            <v-list-item-subtitle>
              <span class="fonte fonteMini text--green">
                {{
                  $helper.formataSaldo(
                    get_gestordepedido.compra.total_recebido || "0"
                  )
                }}
                /
                {{
                  $helper.formataSaldo(get_gestordepedido.compra.preco_total)
                }}
              </span>
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-chip x-small class="fonte text-weight-bold" v-if="get_gestordepedido.compra.desconto" color="orange lighten-2" style="border-radius: 3px;">
                Desconto: {{
                  $helper.formataSaldo(
                    get_gestordepedido.compra.desconto
                  )
                }}
              </v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="printReceipt(get_gestordepedido)"
          style="border-radius: 6px; margin-bottom: 6px; background: #e5e5e5;"
        >
          <v-icon size="18" class="mr-2">mdi-receipt-outline</v-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span class="fonte">Imprimir Venda</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="!get_gestordepedido.external_movimentation"
          @click="prepareDelivery(get_gestordepedido)"
          style="border-radius: 6px; margin-bottom: 6px; background: #e5e5e5;"
        >
          <v-icon size="18" class="mr-2">mdi-calendar</v-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span class="fonte">Criar agendamento</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          @click="confirmCancel"
          style="border-radius: 6px; margin-bottom: 6px; background: #e5e5e5;"
          v-if="
            get_gestordepedido.status_do_pagamento === 'pendente' &&
              get_gestordepedido.status !== 'cancelado' &&
              get_gestordepedido.status !== 'concluído'
          "
        >
          <v-icon size="18" class="mr-2">mdi-cancel</v-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span class="fonte">Cancelar a venda</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <!-- <v-autocomplete 
        solo
        dense
        flat
        background-color="#e5e5e5"
        :color="$theme.primary"
        hide-details
        :items="kanbans"
        item-text="name"
        return-object
        prepend-inner-icon="mdi-send"
        label="Mover"
      ></v-autocomplete> -->
      <!-- <CosmosPluginStore context="sale" /> -->
      <!-- <cosmos-plugin-store context="sale"/> -->
    </v-flex>
    <EventDialog ref="eventDialog" origin="sale-body" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CosmosPluginStore from "@/apps/CosmosPluginStore/index.vue";
import MembersPlugin from "@/apps/CosmosPluginStore/plugins/members/index.vue";
import TagPlugin from "@/apps/CosmosPluginStore/plugins/tag/index.vue";
import InPreparationStage from "../../components/SaleStages/in_preparation/index.vue";
import ViewExternalMovimentation from "../../components/ViewExternalMovimentation/index.vue";
import PaymentLogs from "../../components/paymentLogs/index.vue";
import Files from "./saleFiles.vue";
import SaleLog from "./saleLog.vue";
import SaleTenantMovementPanel from "./SaleTenantMovementPanel.vue";
import SaleTechnicalDrawingPanel from "./SaleTechnicalDrawingPanel.vue";
import EventDialog from "@/apps/ExternalMovimentation/components/EventDialog.vue";
import PlateViewer from '@/apps/27#Caixas/components/plateViewer/index.vue';

export default {
  props: [
    "openReceiptEmitter",
    "printReceipt",
    "printDeliveryNote",
    "printExitNote",
    "printTechnicalDrawing",
    "configureDeliveryNote",
    "confirmCancel",
    "sendToPdv",
    "initPayment",
    "hideActions"
  ],
  components: {
    CosmosPluginStore,
    PaymentLogs,
    MembersPlugin,
    TagPlugin,
    InPreparationStage,
    SaleLog,
    SaleTenantMovementPanel,
    SaleTechnicalDrawingPanel,
    EventDialog,
    ViewExternalMovimentation,
    Files,
    PlateViewer
  },
  computed: {
    ...mapGetters(["get_gestordepedido"]),
    isDark() {
      return localStorage.dark === "true";
    },
    deliveryNotes() {
      return Array.isArray(this.get_gestordepedido.delivery_notes)
        ? this.get_gestordepedido.delivery_notes
        : [];
    },
    paymentTotal() {
      return Number(this.get_gestordepedido?.compra?.preco_total || 0);
    },
    paymentPaid() {
      return Number(this.get_gestordepedido?.compra?.total_recebido || 0);
    },
    paymentRemaining() {
      return Math.max(this.paymentTotal - this.paymentPaid, 0);
    }
  },
  data() {
    return {
      kanbans: JSON.parse(localStorage.getItem("kanbans")) || [],
      reprintingNote: ""
    };
  },
  methods: {
    ...mapActions(["fecha_modal_view_gestordepedido", "update_transaction_files", "createGlobalMessage"]),
    addTagOnSale(tag) {
      console.log("bateu", tag);
      // this.$store.dispatch("addTagOnSale", tag);
    },
    updateFiles(files) {
      this.update_transaction_files(files)
        .then(res => {
          console.log(res);
          this.$forceUpdate();
        })
    },
    removeTagFromSale(tag) {
      console.log("bateuw", tag);
      // this.$store.dispatch("removeTagFromSale");
    },
    prepareDelivery(sale) {
      this.$refs.eventDialog.open(sale, "sale");
    },
    editDelivery() {
      this.$refs.eventDialog.open(
        this.get_gestordepedido.external_movimentation,
        "open-event"
      );
    },
    personName(user = {}) {
      return user && user.nome ? user.nome.split(" ")[0] : "Usuario";
    },
    async reprintDeliveryNote(note) {
      if (!this.printDeliveryNote) return;
      this.reprintingNote = note._id || note.number;
      try {
        const response = await this.$run("transacoes/register-delivery-note-print", {
          _id: this.get_gestordepedido._id
        });
        const sale = response.data && response.data.sale ? response.data.sale : this.get_gestordepedido;
        this.$store.commit("set_gestordepedido", sale);
        await this.$nextTick();
        this.printDeliveryNote(sale);
      } catch (error) {
        this.createGlobalMessage({
          type: "warning",
          message: error.response?.data?.message || "Nao foi possivel registrar a reimpressao.",
          timeout: 5000
        });
      } finally {
        this.reprintingNote = "";
      }
    }
  }
};
</script>

<style scoped>
.delivery-note-chip {
  background: #ffffff !important;
  border: 1px solid #128c7e !important;
  color: #126b61 !important;
  font-weight: 700;
}

.sale-option-item {
  background: #f7f9fb !important;
  border: 1px solid #e0e7ee;
  border-radius: 8px;
  margin-bottom: 6px;
  min-height: 54px;
  transition: 0.16s ease;
}

.sale-option-item:hover {
  background: #ffffff !important;
  border-color: #128c7e;
}

.sale-option-delivery {
  background: #f4faf8 !important;
}

.sale-option-icon {
  align-items: center;
  background: #e3f4ee;
  border-radius: 8px;
  color: #128c7e;
  display: flex;
  height: 34px;
  justify-content: center;
  margin-right: 10px;
  width: 34px;
}

.delivery-notes-panel {
  background: #f7fafc;
  border: 1px solid #dfe7ef;
  border-radius: 8px;
  margin: 10px 8px 4px;
  padding: 16px;
}

.delivery-notes-header {
  align-items: center;
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.delivery-notes-header strong,
.delivery-notes-header small,
.delivery-note-main strong,
.delivery-note-main small {
  display: block;
}

.delivery-notes-header strong {
  color: #152432;
  font-size: 16px;
}

.delivery-notes-header small,
.delivery-note-main small {
  color: #6d7c88;
}

.delivery-notes-icon {
  background: #e8f7ef !important;
  color: #1f8f55 !important;
}

.delivery-note-row {
  align-items: center;
  background: #fff;
  border: 1px solid #e5edf3;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 12px;
}

.delivery-note-main {
  min-width: 0;
}

.delivery-note-main strong,
.delivery-note-main small {
  overflow-wrap: anywhere;
}

.delivery-notes-panel.dark {
  background: #111b21;
  border-color: #26343c;
}

.delivery-notes-panel.dark .delivery-note-row {
  background: #182229;
  border-color: #26343c;
}

.delivery-notes-panel.dark .delivery-notes-header strong,
.delivery-notes-panel.dark .delivery-note-main strong {
  color: #eef4f1;
}

.delivery-notes-panel.dark .delivery-notes-header small,
.delivery-notes-panel.dark .delivery-note-main small {
  color: #8ea39a;
}

.delivery-notes-panel.dark .delivery-notes-icon {
  background: #0b3b2a !important;
  color: #9be7bd !important;
}

@media(max-width: 640px) {
  .delivery-note-row {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
